import { useQuery } from "@tanstack/react-query";
import { OptionSelect } from "Common/Components";
import {
  getDefaultValueForSelect,
  userType,
  validateUserTypePermited,
} from "helpers/functionsHelpers";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCompanys, getBranchesByCompany } from "services";

export const useSelectSessionValidation = (
  idCopmanieSelect: string,
  idBranchSelect: string
) => {
  const { t } = useTranslation();

  const [companiesOptions, setCompaniesOptions] = useState<OptionSelect[]>([]);
  const [branchesOptions, setBranchesOptions] = useState<OptionSelect[]>([]);

  const [companyValue, setCompanyValues] = useState<OptionSelect>();
  const [branchValue, setBranchValues] = useState<OptionSelect>();

  const [idCopmanie, setIdCopmanie] = useState<string>(idCopmanieSelect);
  const [idBranch, setIdBranch] = useState<string>(idBranchSelect);

  const {
    data: companies,
    isLoading: companiesLoading,
    error: companiesError,
  } = useQuery({
    queryKey: ["getAllCompanies"],
    queryFn: getCompanys,
  });

  const { data: branches } = useQuery({
    queryKey: ["getBranchesByCompany", idCopmanie],
    queryFn: () => getBranchesByCompany(idCopmanie),
    enabled: !!idCopmanie,
  });

  useEffect(() => {
    setCompanyValues(getDefaultValueForSelect(companiesOptions, idCopmanie));
  }, [idCopmanie, companiesOptions]);

  useEffect(() => {
    setBranchValues(getDefaultValueForSelect(branchesOptions, idBranch));
  }, [idBranch, branchesOptions]);

  useEffect(() => {
    setIdBranch(idBranchSelect);
  }, [idBranchSelect]);

  useEffect(() => {
    setIdCopmanie(idCopmanieSelect);
  }, [idCopmanieSelect]);

  useEffect(() => {
    if (companies && companies.data) {
      const companiesOptions = companies.data.map((company) => ({
        label: company.name,
        value: company.id.toString(),
      }));

      setCompaniesOptions(companiesOptions);
    }
  }, [companies]);

  useEffect(() => {
    if (branches && branches.data) {
      const branchesOptions = branches.data.map((branch) => ({
        label: branch.description,
        value: branch.id.toString(),
      }));

      setBranchesOptions(branchesOptions);
    }
  }, [branches]);

  const getColSpanBySession = () => {
    return validateUserTypePermited([userType.adminitrador])
      ? "col-span-6"
      : "col-span-12";
  };

  return {
    t,
    companiesOptions,
    companiesLoading,
    companiesError,
    idCopmanie,
    idBranch,
    branchesOptions,
    companyValue,
    branchValue,
    getColSpanBySession,
    setIdBranch,
    setIdCopmanie,
  };
};
